import type { ScanType, ScannerEngine } from '@/types/scan';

export const scanTypes: { value: ScanType; label: string; description: string }[] = [
  { value: 'full', label: 'Full Scan', description: 'Run all scanner engines (nmap, nuclei, custom checks, SSH/WinRM audit)' },
  { value: 'discovery', label: 'Discovery', description: 'Port and service discovery only (Nmap)' },
  { value: 'vulnerability', label: 'Vulnerability', description: 'Vulnerability scanning (Nuclei + custom checks)' },
  { value: 'web', label: 'Web Application', description: 'Web server scanning (Nikto + custom checks)' },
  { value: 'ssl', label: 'SSL/TLS', description: 'TLS configuration assessment (SSLyze)' },
  { value: 'custom', label: 'Custom', description: 'Choose specific scanner engines manually' },
];

export const engines: { value: ScannerEngine; label: string }[] = [
  { value: 'nmap', label: 'Nmap (Port Discovery)' },
  { value: 'nuclei', label: 'Nuclei (Vuln Templates)' },
  { value: 'custom_checks', label: 'Custom Checks (Headers, DNS, Paths)' },
  { value: 'ssh_audit', label: 'SSH Audit (Authenticated Linux)' },
  { value: 'winrm_audit', label: 'WinRM Audit (Authenticated Windows)' },
  { value: 'nikto', label: 'Nikto (Web Server)' },
  { value: 'sslyze', label: 'SSLyze (TLS/SSL)' },
];
